<template>
  <div>
    <b-card header="Synthèse par date">
      <form v-on:submit.prevent="onSyntheseQuerySubmit" method="POST">
        <div class="row">
          <div class="col-sm-4">
            <b-form-group label="Date de début" label-for="startDate" class="form-table">
              <b-form-input
                id="startDate"
                name="startDate"
                type="date"
                min="0"
                size="sm"
                class="form-control frm-c"
                v-model="queryParams.startDate"
              />
            </b-form-group>
          </div>
          <div class="col-sm-3">
            <b-form-group label="Date de fin" label-for="endDate" class="form-table">
              <b-form-input
                id="endDate"
                name="endDate"
                type="date"
                min="0"
                size="sm"
                class="form-control frm-c"
                v-model="queryParams.endDate"
              />
            </b-form-group>
          </div>
          <div class="col-sm-3">
            <div class="form-group">
              <label class="control-label" for="complianceSurveyOnly">Type de synthèse</label>
              <div class="input-group">
                <multiselect
                  id="synthesisType"
                  v-model="queryParams.type"
                  name="synthesisType"
                  :options="synthesisType"
                  track-by="id"
                  label="label"
                />
              </div>
            </div>
          </div>
          <div class="col-sm-2">
            <a
              type="submit"
              v-bind:disabled="!queryParams.type || !queryParams.startDate || !queryParams.endDate"
              class="btn btn-cta s-btn mgt-25"
              v-bind:href="'/fr/syntheses/query.csv?' + (queryParams.startDate ? 'filterFields[]=controls_0_flatStatus_generatedMail_createdAt>' + queryParams.startDate : '') + (queryParams.endDate ? '&filterFields[]=controls_0_flatStatus_generatedMail_createdAt<' + queryParams.endDate+'T24:00' : '') + (queryParams.type ? '&synthesisFilterSetType=' + queryParams.type.id : '') + '&v='+formatDateTimestamp()"
              target="_blank"
              size="sm"
            >Télécharger</a>
          </div>
        </div>
      </form>
    </b-card>
    <hr />
    <b-card header="Synthèse complète">
      <form v-on:submit.prevent="onSyntheseQuerySubmit" method="POST">
        <div class="row">
          <div class="col-sm-3">
            <div class="form-group">
              <label class="control-label" for="complianceSurveyOnly">Type de synthèse</label>
              <div class="input-group">
                <multiselect
                  id="synthesisType"
                  v-model="queryParams.typeComplet"
                  name="synthesisType"
                  :options="optionsSyntheseComplete"
                  track-by="id"
                  label="label"
                />
              </div>
            </div>
          </div>
          <div class="col-sm-2">
            <a
              type="submit"
              v-bind:disabled="!queryParams.typeComplet"
              class="btn btn-cta s-btn mgt-25"
              v-bind:href="'/fr/syntheses/query.csv?' + (queryParams.typeComplet ? '&synthesisFilterSetType=' + queryParams.typeComplet.id : '') + '&v='+formatDateTimestamp()"
              target="_blank"
              size="sm"
            >Télécharger</a>
          </div>
        </div>
      </form>
    </b-card>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { formatDateTimestamp } from '../../utils/formatDate';

export default {
  components: {},
  data() {
    return {
      synthesisType: [],
      queryParams: {
        startDate: null,
        endDate: null,
        type: null,
        typeComplet: null,
      },
      options: [
        { value: 'vpt', text: 'Visite Pendant Travaux' },
        { value: 've', text: 'Visite d’Entretien' },
        { value: 'conformite_rainy', text: 'Conformité pour projets pluviaux' },
        { value: 'all_property', text: 'Toutes les propriétés' },
        { value: 'cc_totaux', text: 'Contrôles effectués totaux' },
        { value: 'cnc', text: 'Contrôles NC' },
        { value: 'lnc', text: 'Levées de NC' },
      ],
      optionsSyntheseComplete: [{ id: 'ep', label: 'Synthèse rétention EP' }],
      items: [],
    };
  },
  computed: {
    ...mapState({
      types: state => state.refSynthesis.types,
    }),
  },
  created: function() {
    this.getSynthesisTypes();
  },
  methods: {
    getSynthesisTypes() {
      this.$store.dispatch('fetchSynthesisTypes').then(() => {
        this.loaderData = false;
        this.types.forEach(v => {
          if (v.id !== 'ep') {
            this.synthesisType.push(v);
          }
        });
      });
    },
    onSyntheseQuerySubmit: function() {
      this.$store.commit('submitSyntheseQuery', this.queryParams);
    },
    formatDateTimestamp: function() {
      return formatDateTimestamp();
    },
  },
};
</script>

<style>
.frm-c {
  height: 38px !important;
  font-size: 15px !important;
}
.mgt-25 {
  margin-top: 25px !important;
}
#app .card-header {
  text-align: left;
  font-weight: 700;
  padding-top: 15px;
  padding-bottom: 15px;
}
</style>